module.exports = __webpack_public_path__ + "static/media/trainingProgressHeader.bd256cfe.jpg";